<template>
    <div class="fans">
        <div class="fans_top">订单管理</div>
        <div class="fans_block am-cf">
            <div class="fans_block_list am-fl" @click="fans(1)">
                <p class="">粉丝订单</p>
                <p class="fans_line" :class="types==1?'':'fans_lines'"></p>
            </div>
            <div class="fans_block_list am-fl" @click="fans(2)">
                <p class="">会员订单</p>
                <p class="fans_line" :class="types==2?'':'fans_lines'"></p>
            </div>
        </div>
        <div class="fans_item am-cf" v-if="types==1" >
            <div class="fans_item_lists am-fl" :class="lists==1?'fans_item_listss':''" @click="vips(1)">待发货0</div>
            <div class="fans_item_lists am-fl" :class="lists==2?'fans_item_listss':''" @click="vips(2)">待收货0</div>
            <div class="fans_item_lists am-fl" :class="lists==3?'fans_item_listss':''" @click="vips(3)">待评价0</div>
            <div class="fans_item_lists am-fl" :class="lists==4?'fans_item_listss':''" @click="vips(4)">已完成0</div>
        </div>
         <div class="fans_item am-cf" v-if="types==2" >
                这里是会员订单
        </div>
    </div>
</template>
<script>
export default {
  data: function () {
    return {
        types:1,
        lists:1,
        items:1,
    };
  },
  mounted: function () {},
  methods: {
      fans(type){
          this.types=type
      },
      vips(list){
          this.lists = list
      },
      hhh(item){
          this.items = item
      }
  },
};
</script>

<style scoped>
    .fans{ width: 100%;}
    .fans_top{ font-size: 18px;color: #000;line-height: 40px; text-align: center; }
    .fans_block{ width: 100%;background-color: #fff;}
    .fans_block .fans_block_list{width: 50%;color: #333;line-height: 35px;font-size: 16px;text-align: center;}
    .fans_line{width: 40px;height: 2px;background-color: rgb(245, 18, 18);display: block;margin: 0 auto;}
    .fans_lines{background-color: #fff;}
    .fans_item{width: 100%;line-height: 35px;background-color: #fff;margin-top: 10px;}
    .fans_item_list{width: 50%;text-align: center;border: 1px solid rgb(245, 18, 18);border-bottom: 0px;background-color: #fff;color: #333;}
    .fans_item_listss{background-color: rgb(245, 18, 18)!important;color: #fff!important;}
    .fans_item_lists{width: 25%;text-align: center;border: 1px solid rgb(245, 18, 18);border-bottom: 0px;background-color: #fff;color: #333;}
</style>

